import styled from '@emotion/styled';
import { COLORS, FONT, SPACING } from '../../../styles/emotion';

export const CheckboxListWrapper = styled.div`
  .checkbox-list-item {
    margin-bottom: 10px;
  }
  .inline {
    display: flex;
    .checkbox-list-item {
      margin-right: ${SPACING.MD};
      .selector-dek {
        max-width: 200px;
      }
    }
  }
  &.error {
    .checkbox-icon-wrapper {
      border: 2px solid ${COLORS.RED_MESSAGING};
    }
  }
`;

export const Label = styled.p`
  color: ${COLORS.BLACK};
  font-size: ${FONT.FONT_SIZE_SMALL};
  text-transform: capitalize;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
`;

export const checkboxListItem = styled.div;
